import styled from "styled-components";
import { colorMixin, typographyMixin } from "../../helpers";

export const Pictures = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 16px;
`;

export const PictureList = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
`;

export const PicturePreview = styled.button`
    cursor: pointer;
    display: flex;
    flex-direction: column;
    width: 205px;
    height: 163px;
    overflow: hidden;
    background: transparent;
    padding: 0;
    border: 1px solid ${colorMixin("border-primary-100")};
    border-radius: 8px;
`;

export const PreviewHeader = styled.div`
    box-sizing: border-box;
    width: 100%;
    height: 44px;
    display: flex;
    padding: 12px;
    justify-content: space-between;
    align-items: center;
`;

export const PictureImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

export const FullImage = styled.img`
    max-height: calc(100vh - 200px);
    border-radius: 8px;
`;

export const Header = styled.div`
    ${typographyMixin("label-x-small-regular")};
    color: ${colorMixin("text-primary-600")};
    text-transform: uppercase;
    letter-spacing: 0.08em;
`;

export const MoreToggle = styled(PicturePreview)`
    border-color: ${colorMixin("border-primary-200")};
    display: flex;
    justify-content: center;
    align-items: center;
`;
